import { gql } from '@apollo/client';

export const CREATE_LOCALIZATION_MUTATION = gql`
    mutation createResourceLocalization($input: CreateResourceLocalizationInput!) {
        result: createResourceLocalization(input: $input) {
            id 
            localeCode
            isDefault 
            name
            description
            createdAt
            resourceUrlId
            resourceUrl {
                node {
                    id
                    url
                }
            }
            resourceFileId
            resourceFile{
                node{
                    id
                    genericFile
                    lxpFile
                }
            }
        }
    }
`;